import { FleetTireSetLocationEntityType, FleetTireSetRow } from "services/api/fleet/tires/types";
import Badge from "ui/components/Badge/Badge";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import VehicleCell from "ui/components/Table/TableSearch/components/Cells/VehicleCell";

export const TIRE_TYPE_BACKGROUND = (code: string) => {
  switch (code) {
    case "W":
      return (
        <div className="relative w-3 h-3 rounded-full overflow-hidden">
          <div className="absolute top-0 left-0 w-1/2 h-full bg-blue-500"></div>
          <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-500"></div>
        </div>
      );
    case "S":
      return (
        <div className="relative w-3 h-3 rounded-full overflow-hidden">
          <div className="absolute top-0 left-0 w-1/2 h-full bg-yellow-500"></div>
          <div className="absolute top-0 right-0 w-1/2 h-full bg-yellow-500"></div>
        </div>
      );
    case "U":
      return (
        <div className="relative w-3 h-3 rounded-full overflow-hidden">
          <div className="absolute top-0 left-0 w-1/2 h-full bg-blue-500"></div>
          <div className="absolute top-0 right-0 w-1/2 h-full bg-yellow-500"></div>
        </div>
      );
    default:
      return "";
  }
};

export const TIRE_SET_SEARCH_COLUMNS = (
  t: (key: string) => string,
  handleDeleteClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleLocationClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    entityId: string,
    entityName: string
  ) => void,
  handleEditClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleDemountClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleMountClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleRelocateClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void,
  handleWriteOffClick: (
    event: React.MouseEvent<HTMLSpanElement>,
    id: string
  ) => void
): Column[] => [
    {
      title: "admin.fleet.tire.set.search.code",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        return <div className="flex gap-2 items-center">{row.code}</div>;
      },
    },
    {
      title: "admin.fleet.tire.set.search.size",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        const dimension = Array.from(
          new Set(
            row.childRows
              ?.map(r => `${r.width}/${r.height} R${r.radius}`)
              .filter(Boolean)
          )
        ).join(", ");
        return (
          <div className="text-md ">
            {dimension}
          </div>
        );
      },
    },
    {
      title: "admin.fleet.tire.set.search.tiretype",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        const tireType = row.childRows?.[0]?.tireType;
        return <div className="flex gap-2 items-center">{tireType && TIRE_TYPE_BACKGROUND(tireType?.id)} <div className="text-md">{tireType?.name}</div></div>;
      },
    },
    {
      title: "admin.fleet.tire.set.search.manufacturer",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        const tireManufacturers = Array.from(
          new Set(
            row.childRows
              ?.map(r => `${r.tireManufacturer?.name}`)
              .filter(Boolean)
          )
        ).join(", ");
        return (
          <div>
            <div className="text-md">{tireManufacturers}</div>
          </div>
        );
      },
    },
  
    {
      title: "admin.fleet.tire.set.search.location",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        if (!row.location) return <></>;
        if (
          row.location.entityName === FleetTireSetLocationEntityType.Vehicle &&
          row.vehicle
        ) {
          return (
            <VehicleCell
              vehicle={row.vehicle}
              onClick={(e) =>
                handleLocationClick(e, row.location.entityId, row.location.entityName)
              }
            />
          );
        }
        return (
          <div className="inline-flex gap-3 items-center text-md font-medium truncate text-sky-600 hover:text-sky-900 text-sm cursor-pointer">
            <span onClick={(e) => handleLocationClick(e, row.location.entityId, row.location.entityName)}>
              {row.location.destination}
            </span>
          </div>
        );
      },
    },
    {
      title: "admin.fleet.tire.set.search.lastvehicle",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        if (row.location?.entityName === FleetTireSetLocationEntityType.Vehicle) {
          return <></>;
        }
        if (!row.lastVehicle) return <></>;
        return (
          <VehicleCell
            vehicle={row.lastVehicle}
            onClick={(e) =>
              handleLocationClick(e, row.lastVehicle!.id, FleetTireSetLocationEntityType.Vehicle)
            }
          />
        );
      },
    },
    {
      title: "admin.fleet.tire.set.search.isactive",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        return <Badge text={row.isActive ? t("DA") : t("NE")} variant={row.isActive ? "success" : "warning"} showDot />;
      },
    },
    {
      title: "admin.fleet.tire.set.search.writtenoff",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        return row.isWrittenOff ? (
          <Badge text="Otpisano" variant="danger" showDot />
        ) : (
          <></>
        );
      },
    },
    {
      title: "",
      field: "",
      type: ColumnTypes.custom,
      render: (row: FleetTireSetRow) => {
        console.log('row', row)
        return (
          <ButtonMenu
            endIcon="/media/icons/more-dots.svg"
            cssClassName="h-full"
            variant="text"
          >
            {row.location?.entityName === "Vehicle" ? (
              <ButtonMenuItem
                startIcon="/media/icons/tire-demount.svg"
                onClick={(e) => handleDemountClick(e, row.id)}
              >
                Demontaža guma sa vozila
              </ButtonMenuItem>
            ) : (
              <>
                <ButtonMenuItem
                  startIcon="/media/icons/tire-mount.svg"
                  onClick={(e) => handleMountClick(e, row.id)}
                >
                  Montaža guma na vozilo
                </ButtonMenuItem>
                <ButtonMenuItem
                  startIcon="/media/icons/warehouse.svg"
                  onClick={(e) => handleRelocateClick(e, row.id)}
                >
                  Premještaj na skladište
                </ButtonMenuItem>
              </>
            )}
            <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              disabled={row.location?.entityName === "Vehicle" || row.isWrittenOff}
              tooltip="Set guma ne može biti otpisan dok je montiran na vozilo. Prvo napravite demontažu na skladište."
              onClick={(e) => handleWriteOffClick(e, row.id)}
            >
              Otpis
            </ButtonMenuItem>
            {/* <ButtonMenuItem
              startIcon="/media/icons/trash.svg"
              variant="remove"
              disabled={row.isActive || row.isWrittenOff}
              tooltip="Set guma je montiran na vozilo i ne može se obrisati. Ukoliko ga želite obrisati napravite prvo transfer guma na skladište."
              onClick={(e) => handleDeleteClick(e, row.id)}
            >
              Obriši
            </ButtonMenuItem> */}
          </ButtonMenu>
        );
      },
    },
  ];

export const TIRE_SEARCH_COLUMNS = (t: (key: string) => string): Column[] => [
    {
    title: "admin.fleet.tire.search.dimension",
    field: "",
    type: ColumnTypes.string,
  },
    {
    title: "admin.fleet.tire.search.type",
    field: "",
    type: ColumnTypes.string,
  },
  {
    title: "admin.fleet.tire.search.manufacturer",
    field: "",
    type: ColumnTypes.string,
  },
  {
    title: "admin.fleet.tire.search.dot",
    field: "",
    type: ColumnTypes.string,
  },
  {
    title: "admin.fleet.tire.search.profiledepth",
    field: "",
    type: ColumnTypes.string,
  },
];
